export default __webpack_public_path__ + "static/media/sv.eb2538c6.svg";